import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, of, ReplaySubject, Subscription } from 'rxjs';
import { debounceTime, map, tap } from 'rxjs/operators';
import { environment as env } from '../../../environments/environment';
import { Product, ProductObservable } from '../../models/product.model';
import { BuyersApiService } from '../../services/buyers-api.service';
import { MediaService } from '../../services/media.service';
import { ShoppingCartService } from '../../services/shoppingcart.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  private totals: any; // TODO: type?
  information: string; // TODO: not sure what we used this for. error messages?
  true$ = of(true); // need this to keep products expanded by default
  locale: string;
  desktop = true;

  public products$: Observable<ProductObservable[]>;
  private subjects: Record<string, ReplaySubject<Product>> = {};
  private observables: Record<string, Observable<Product>> = {};

  constructor(
    public shoppingCartService: ShoppingCartService,
    public buyersApiService: BuyersApiService,
    private translate: TranslateService,
    private mediaObserver: MediaObserver,
    public mediaService: MediaService,
    private router: Router,
    private activedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    // language changes
    this.subscriptions.set('translationLanguageChanged',
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.locale = event.lang;
      })
    );

    // listen for browser size changes
    this.subscriptions.set('mediaViewportChanged',
      this.mediaObserver.asObservable().subscribe((changes: MediaChange[]) => {
        const change = changes.pop();
        if (change) {
          this.desktop = !(change.mqAlias === 'xs' || change.mqAlias === 'sm');
        }
      })
    );

    // product observables
    this.products$ = this.shoppingCartService.itemsAsProducts
      .pipe(
        debounceTime(100),
        tap(products => {
          const codes = products.map(product => product.code);
          const unusedSubjects = Object.keys(this.subjects).filter(code => !codes.includes(code));
          unusedSubjects.forEach(code => {
            this.subjects[code].complete();
            delete this.subjects[code];
            delete this.observables[code];
          });
          products.forEach(product => {
            this.subjects[product.code] = this.subjects[product.code] || new ReplaySubject<Product>(1);
            this.observables[product.code] = this.subjects[product.code].asObservable();
            this.subjects[product.code].next(product);
          });
        }),
        map(products => products.map(product => ({ code: product.code, observable: this.observables[product.code] }))),
      );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  setStatus() {
    if (!this.totals || !this.totals.weightPercent) {
      this.information = undefined;
      return;
    }
    if (this.totals.weightPercent < (env.requiredTruckFillPercent || 3)) {
      this.information = this.translate.instant('DELIVERY_DETAILS.TEXT_STATUS_TRUCK_NOT_FILLED');
    } else if (this.totals.weightPercent > 100) {
      this.information = this.translate.instant('DELIVERY_DETAILS.TEXT_STATUS_TRUCK_OVER_CAPACITY');
    } else {
      this.information = undefined;
    }
  }

  trackByCode = (index: number, item: ProductObservable) => item.code;

  goBack() {
    this.router.navigate(['..', 'packages'], { relativeTo: this.activedRoute });
  }

}
